@if(contract){


<ng-container *transloco="let t">

<c-card-body>
  <c-row>
      <div class="signup-steps">

        <div [hidden]="contract.completed"> 

        <c-col  md="12">
        <!-- Step 1 -->
        <c-card class="mb-3" [hidden]="step != 1">
          <c-card-header>
            <h5 class="mb-0">Confirm your OK Alone Plan</h5>
          </c-card-header>
          <c-card-body>

            @if (okService.billing.plan.account_type == "Pricing2024") {
              <app-account-plan-2024></app-account-plan-2024>
            }
            @else {
              <app-account-plan></app-account-plan>
            }

            <div class="text-center mt-3">
              <button type="button" class="btn btn-success text-white btn-lg" (click)="submitPlanConfirmed()" [disabled]="okService.loading">
                <span *ngIf="okService.loading"><i class="fa-solid fa-spinner fa-spin"></i> &nbsp;</span>
                {{ t('Continue Terms and Conditions') }} >>
              </button>
            </div>


          </c-card-body>
        </c-card>
        </c-col>  

        <c-col  lg="6" md="8" sm="12">
        <!-- Step 2 -->
        <c-card class="mb-3" [hidden]="step != 2">
          <c-card-header>
            <h5 class="mb-0">Read Terms and Conditions</h5>
          </c-card-header>
          <c-card-body>
            <!-- Step 2 content will go here -->

            <p>Please read the terms and conditions below. If you agree, please scroll to the bottom and click the button below to continue.</p>

            <div class="terms-and-conditions">
              <div class="terms-scroll" #termsScroll (scroll)="onTermsScroll($event)">
                <div [innerHTML]="termsAndConditions"></div>
              </div>
            </div>   
            <button type="button" 
                    class="btn btn-success text-white btn-lg" 
                    (click)="submitTandCsConfirmed()" 
                    [disabled]="!hasScrolledToBottom || okService.loading">
              <span *ngIf="okService.loading"><i class="fa-solid fa-spinner fa-spin"></i> &nbsp;</span>
              {{ t('I Agree to and Have Read the Terms and Conditions') }} >>
            </button>
          </c-card-body>
        </c-card>
        </c-col>

        
        <c-col  lg="6" md="8" sm="12">
        <!-- Step 3 -->
        <c-card class="mb-3" [hidden]="step != 3">
          <c-card-header>
            <h5 class="mb-0">Sign Contract</h5>
          </c-card-header>
          <c-card-body>
            <div class="text-center mb-4">
            
            <p>Thank you for agreeing to the terms and conditions.</p>
            <!-- Step 3 content will go here -->

              <p>
                <b>Contract Start:</b> {{ contract.contract_start_date }} <br/>
                <b>Contract End:</b> {{ contract.contract_end_date }}
              </p>

              <p>Please enter your name and signature below to sign the contract.</p>
            </div>

            <form (ngSubmit)="submitSignature()" class="signature-form">
              <div class="form-group row mb-3">
                <label class="col-4 col-form-label text-start text-sm-end">{{ t('Full Name') }}</label>
                <div class="col-8">
                  <input
                    [(ngModel)]="signature_name"
                    name="name"
                    cFormControl
                    placeholder="Enter your full name"
                    [ngClass]="{ 'border-danger': submitted && !signature_name }"
                    required
                  />
                  <div *ngIf="submitted && !signature_name" class="invalid-feedback">
                    {{ t('Full Name') }} {{ t('is required') }}
                  </div>
                </div>
              </div>
              <div class="signature-container text-center">
                <span class=" p-1">{{ t('Please sign your name below:') }}<br/></span> 
                <signature-pad 
                  #signature 
                  [options]="signaturePadOptions" 
                  (drawStart)="drawStart($event)" 
                  (drawEnd)="drawComplete($event)"
                  class="signature-pad">
                </signature-pad>
              </div>
              <div *ngIf="submitted && (!signature || signature.isEmpty())" class="invalid-feedback text-center">
                {{ t('Signature') }} {{ t('is required') }}
              </div>

              <br/><br/>
            
              <div class="form-group row">
                <div class="col-8 offset-4">
                  <div class="d-flex gap-2" *ngIf="signature">
                    <button type="submit" class="btn btn-success text-white" [disabled]="okService.loading || signature.isEmpty() || !signature_name">
                      <span *ngIf="okService.loading"><i class="fa-solid fa-spinner fa-spin"></i> &nbsp;</span>
                      {{ t('Accept & Sign the Contract') }}
                    </button>
                    <button type="button" class="btn btn-secondary" (click)="signature?.clear()">
                      {{ t('Clear Signature') }}
                    </button>
                  </div>
                </div>
              </div>
            </form>

          </c-card-body>
        </c-card>
        </c-col>

        
        <c-col  md="12">
        <!-- Step 4 -->
        <c-card class="mb-3" [hidden]="step != 4">
          <c-card-header>
            <h5 class="mb-0">Enter Payment Details</h5>
          </c-card-header>
          <c-card-body>
            <app-account-card></app-account-card>
          </c-card-body>
        </c-card>
        </c-col>

      </div>

        
        <div class="alert alert-success" role="alert" *ngIf="contract.completed">
          <i class="fa-solid fa-check-circle fa-lg"></i> &nbsp;{{ t('Your Contract Setup is Complete') }}.
        </div>

    
      </div>
  </c-row>
</c-card-body>

</ng-container>

}